// Action for supplier

import {
  GET_SUPPLIER_LIST,
  GET_SUPPLIER_LIST_FAILURE,
  GET_SUPPLIER_LIST_SUCCESS,
  GET_SUPPLIER_DETAILS,
  GET_SUPPLIER_DETAILS_SUCCESS,
  GET_SUPPLIER_DETAILS_FAILURE,
  CREATE_SUPPLIER,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,
  UPDATE_SUPPLIER,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAILURE,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
  GET_SUPPLIER_RECENT_ACTIVITY,
  GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS,
  GET_SUPPLIER_RECENT_ACTIVITY_FAILURE,
  SEARCH_SUPPLIER_NOTE,
  SEARCH_SUPPLIER_NOTE_SUCCESS,
  SEARCH_SUPPLIER_NOTE_FAILURE,
  CREATE_SUPPLIER_NOTE,
  CREATE_SUPPLIER_NOTE_SUCCESS,
  CREATE_SUPPLIER_NOTE_FAILURE,
  DELETE_SUPPLIER_NOTE,
  DELETE_SUPPLIER_NOTE_SUCCESS,
  DELETE_SUPPLIER_NOTE_FAILURE,
  SEARCH_SUPPLIER_ATTACHMENT,
  SEARCH_SUPPLIER_ATTACHMENT_SUCCESS,
  SEARCH_SUPPLIER_ATTACHMENT_FAILURE,
  DELETE_SUPPLIER_ATTACHMENT,
  DELETE_SUPPLIER_ATTACHMENT_SUCCESS,
  DELETE_SUPPLIER_ATTACHMENT_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE,
  SEARCH_SUPPLIER_URL_LINK,
  SEARCH_SUPPLIER_URL_LINK_SUCCESS,
  SEARCH_SUPPLIER_URL_LINK_FAILURE,
  GET_SUPPLIER_URL_LINK_DETAILS,
  GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS,
  GET_SUPPLIER_URL_LINK_DETAILS_FAILURE,
  CREATE_SUPPLIER_URL_LINK,
  CREATE_SUPPLIER_URL_LINK_SUCCESS,
  CREATE_SUPPLIER_URL_LINK_FAILURE,
  UPDATE_SUPPLIER_URL_LINK,
  UPDATE_SUPPLIER_URL_LINK_SUCCESS,
  UPDATE_SUPPLIER_URL_LINK_FAILURE,
  DELETE_SUPPLIER_URL_LINK,
  DELETE_SUPPLIER_URL_LINK_SUCCESS,
  DELETE_SUPPLIER_URL_LINK_FAILURE,
  GET_SUPPLIER_URL_LINK_STATUS_LIST,
  GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS,
  GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE,
  GET_SUPPLIER_URL_LINK_TYPE_LIST,
  GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS,
  GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE,
} from "./actionType";

// Get Supplier List Action

export const getSupplierList = () => {
  return {
    type: GET_SUPPLIER_LIST,
  };
};

export const getSupplierListSuccess = (data) => {
  return {
    type: GET_SUPPLIER_LIST_SUCCESS,
    payload: data,
  };
};

export const getSupplierListFailure = (error) => {
  return {
    type: GET_SUPPLIER_LIST_FAILURE,
    payload: error,
  };
};

// Get Single Supplier Details Action

export const getSupplierDetails = (id) => {
  return {
    type: GET_SUPPLIER_DETAILS,
    payload: id,
  };
};

export const getSupplierDetailsSuccess = (data) => {
  return {
    type: GET_SUPPLIER_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getSupplierDetailsFailure = (error) => {
  return {
    type: GET_SUPPLIER_DETAILS_FAILURE,
    payload: error,
  };
};

// Create New Supplier Action

export const createSupplier = (data) => {
  return {
    type: CREATE_SUPPLIER,
    payload: data,
  };
};

export const createSupplierSuccess = (data) => {
  return {
    type: CREATE_SUPPLIER_SUCCESS,
    payload: data,
  };
};

export const createSupplierFailure = (error) => {
  return {
    type: CREATE_SUPPLIER_FAILURE,
    payload: error,
  };
};

// Update Supplier Action

export const updateSupplier = (data) => {
  return {
    type: UPDATE_SUPPLIER,
    payload: data,
  };
};

export const updateSupplierSuccess = (data) => {
  return {
    type: UPDATE_SUPPLIER_SUCCESS,
    payload: data,
  };
};

export const updateSupplierFailure = (error) => {
  return {
    type: UPDATE_SUPPLIER_FAILURE,
    payload: error,
  };
};

// Delete Supplier Action

export const deleteSupplier = (id) => {
  return {
    type: DELETE_SUPPLIER,
    payload: id,
  };
};

export const deleteSupplierSuccess = (data) => {
  return {
    type: DELETE_SUPPLIER_SUCCESS,
    payload: data,
  };
};

export const deleteSupplierFailure = (error) => {
  return {
    type: DELETE_SUPPLIER_FAILURE,
    payload: error,
  };
};

//GET_SUPPLIER_RECENT_ACTIVITY

export const getSupplierRecentActivity = (id) => {
  return {
    type: GET_SUPPLIER_RECENT_ACTIVITY,
    payload: id,
  };
};

export const getSupplierRecentActivitySuccess = (data) => {
  return {
    type: GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS,
    payload: data,
  };
};

export const getSupplierRecentActivityFailure = (error) => {
  return {
    type: GET_SUPPLIER_RECENT_ACTIVITY_FAILURE,
    payload: error,
  };
};

// Supplier Note Actions

export const searchSupplierNote = (data) => ({
  type: SEARCH_SUPPLIER_NOTE,
  payload: data,
});
export const searchSupplierNoteSuccess = (data) => ({
  type: SEARCH_SUPPLIER_NOTE_SUCCESS,
  payload: data,
});
export const searchSupplierNoteFailure = (error) => ({
  type: SEARCH_SUPPLIER_NOTE_FAILURE,
  payload: error,
});

export const createSupplierNote = (data) => ({
  type: CREATE_SUPPLIER_NOTE,
  payload: data,
});
export const createSupplierNoteSuccess = (data) => ({
  type: CREATE_SUPPLIER_NOTE_SUCCESS,
  payload: data,
});
export const createSupplierNoteFailure = (error) => ({
  type: CREATE_SUPPLIER_NOTE_FAILURE,
  payload: error,
});

export const deleteSupplierNote = (data) => ({
  type: DELETE_SUPPLIER_NOTE,
  payload: data,
});
export const deleteSupplierNoteSuccess = (data) => ({
  type: DELETE_SUPPLIER_NOTE_SUCCESS,
  payload: data,
});
export const deleteSupplierNoteFailure = (error) => ({
  type: DELETE_SUPPLIER_NOTE_FAILURE,
  payload: error,
});

// Supplier Attachment Actions

export const searchSupplierAttachment = (data) => ({
  type: SEARCH_SUPPLIER_ATTACHMENT,
  payload: data,
});
export const searchSupplierAttachmentSuccess = (data) => ({
  type: SEARCH_SUPPLIER_ATTACHMENT_SUCCESS,
  payload: data,
});
export const searchSupplierAttachmentFailure = (error) => ({
  type: SEARCH_SUPPLIER_ATTACHMENT_FAILURE,
  payload: error,
});

export const deleteSupplierAttachment = (data) => ({
  type: DELETE_SUPPLIER_ATTACHMENT,
  payload: data,
});
export const deleteSupplierAttachmentSuccess = (data) => ({
  type: DELETE_SUPPLIER_ATTACHMENT_SUCCESS,
  payload: data,
});
export const deleteSupplierAttachmentFailure = (error) => ({
  type: DELETE_SUPPLIER_ATTACHMENT_FAILURE,
  payload: error,
});

// Supplier Balance Historical Actions

// Monthly snapshots for a single supplier — pass { id: Supplier_Id }
export const getSupplierBalanceHistoricalBySupplier = (id) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER,
  payload: id,
});
export const getSupplierBalanceHistoricalBySupplierSuccess = (data) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS,
  payload: data,
});
export const getSupplierBalanceHistoricalBySupplierFailure = (error) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE,
  payload: error,
});

// Distinct recorded dates for the date picker
export const getSupplierBalanceHistoricalAvailableDates = () => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES,
});
export const getSupplierBalanceHistoricalAvailableDatesSuccess = (data) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
  payload: data,
});
export const getSupplierBalanceHistoricalAvailableDatesFailure = (error) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE,
  payload: error,
});

// Whole-book snapshot for one date — pass { id: date }
export const getSupplierBalanceHistoricalSpecificDate = (date) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  payload: date,
});
export const getSupplierBalanceHistoricalSpecificDateSuccess = (data) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
  payload: data,
});
export const getSupplierBalanceHistoricalSpecificDateFailure = (error) => ({
  type: GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE,
  payload: error,
});

// Supplier Url Link Actions (Task 24318)

// Search links for one supplier — pass [{ supplierurllink_data: { Supplier_Id } }]
export const searchSupplierUrlLink = (data) => ({
  type: SEARCH_SUPPLIER_URL_LINK,
  payload: data,
});
export const searchSupplierUrlLinkSuccess = (data) => ({
  type: SEARCH_SUPPLIER_URL_LINK_SUCCESS,
  payload: data,
});
export const searchSupplierUrlLinkFailure = (error) => ({
  type: SEARCH_SUPPLIER_URL_LINK_FAILURE,
  payload: error,
});

// Read one link — pass { id }
export const getSupplierUrlLinkDetails = (data) => ({
  type: GET_SUPPLIER_URL_LINK_DETAILS,
  payload: data,
});
export const getSupplierUrlLinkDetailsSuccess = (data) => ({
  type: GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS,
  payload: data,
});
export const getSupplierUrlLinkDetailsFailure = (error) => ({
  type: GET_SUPPLIER_URL_LINK_DETAILS_FAILURE,
  payload: error,
});

export const createSupplierUrlLink = (data) => ({
  type: CREATE_SUPPLIER_URL_LINK,
  payload: data,
});
export const createSupplierUrlLinkSuccess = (data) => ({
  type: CREATE_SUPPLIER_URL_LINK_SUCCESS,
  payload: data,
});
export const createSupplierUrlLinkFailure = (error) => ({
  type: CREATE_SUPPLIER_URL_LINK_FAILURE,
  payload: error,
});

export const updateSupplierUrlLink = (data) => ({
  type: UPDATE_SUPPLIER_URL_LINK,
  payload: data,
});
export const updateSupplierUrlLinkSuccess = (data) => ({
  type: UPDATE_SUPPLIER_URL_LINK_SUCCESS,
  payload: data,
});
export const updateSupplierUrlLinkFailure = (error) => ({
  type: UPDATE_SUPPLIER_URL_LINK_FAILURE,
  payload: error,
});

export const deleteSupplierUrlLink = (data) => ({
  type: DELETE_SUPPLIER_URL_LINK,
  payload: data,
});
export const deleteSupplierUrlLinkSuccess = (data) => ({
  type: DELETE_SUPPLIER_URL_LINK_SUCCESS,
  payload: data,
});
export const deleteSupplierUrlLinkFailure = (error) => ({
  type: DELETE_SUPPLIER_URL_LINK_FAILURE,
  payload: error,
});

// Master lists behind the Status / Type badges
export const getSupplierUrlLinkStatusList = () => ({
  type: GET_SUPPLIER_URL_LINK_STATUS_LIST,
});
export const getSupplierUrlLinkStatusListSuccess = (data) => ({
  type: GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS,
  payload: data,
});
export const getSupplierUrlLinkStatusListFailure = (error) => ({
  type: GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE,
  payload: error,
});

export const getSupplierUrlLinkTypeList = () => ({
  type: GET_SUPPLIER_URL_LINK_TYPE_LIST,
});
export const getSupplierUrlLinkTypeListSuccess = (data) => ({
  type: GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS,
  payload: data,
});
export const getSupplierUrlLinkTypeListFailure = (error) => ({
  type: GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE,
  payload: error,
});
